import { ApplicationPermissionsCatalog } from '@shared/types/permissions'
import { createContext } from 'react'

type PermissionsCatalogContextType = {
  catalogs: ApplicationPermissionsCatalog[]
  isLoading: boolean
  getCatalogByType: (type: string) => ApplicationPermissionsCatalog | undefined
}

const initialPermissionsCatalogContext: PermissionsCatalogContextType = {
  catalogs: [],
  isLoading: false,
  getCatalogByType: () => undefined
}

export const PermissionsCatalogContext = createContext(
  initialPermissionsCatalogContext
)
